import { render } from "./CreateApp.vue?vue&type=template&id=88642dfc"
import script from "./CreateApp.vue?vue&type=script&lang=ts"
export * from "./CreateApp.vue?vue&type=script&lang=ts"
script.render = render

export default script